import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-087361ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "estimate_change_tracker" }
const _hoisted_2 = { class: "estimate_change_tracker__list" }
const _hoisted_3 = { class: "estimate_change_tracker__list__item" }
const _hoisted_4 = { class: "left__block" }
const _hoisted_5 = { class: "estimate__changes__card" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Existing", -1))
const _hoisted_7 = { class: "accordion_content" }
const _hoisted_8 = { class: "right__block" }
const _hoisted_9 = { class: "estimate__changes__card" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Changes", -1))
const _hoisted_11 = { class: "accordion_content" }
const _hoisted_12 = { class: "footer__buttons" }

import { computed, reactive, onBeforeMount, watch, ref } from "vue";
import { useStore } from "vuex";
import { JOB_TEMPLATE_STORE } from "@/store/modules/job-template";
import EstimateUpdatePhaseModal from "@/modules/jobs/components/estimates/EstimateUpdatePhaseModal.vue";
import tradeEstimateService from "@/core/services/trade-estimate.service";
import { displayToastMessage } from "@/core/utils/common";
import { getCurrentInstance } from "vue";
import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  __name: 'EstimateChangeTracker',
  props: {
  isTradeSide: {
    type: Boolean,
    default: false,
  },
  modifiedEstimationPhases: {
    type: Array,
  },
  existingEstimatePhases: {
    type: Array,
  },
},
  emits: ["on-back"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const props = __props;
const emits = __emit;
const getDefaultEstimateDetails = computed(
  () => store.getters[`${JOB_TEMPLATE_STORE}/getDefaultEstimateDetails`]
);
const loading = ref(false);
const internalInstance = getCurrentInstance();
const formData = computed(
  () => store.getters[`${JOB_TEMPLATE_STORE}/formData`]
);
const estimateForm = computed(
  () => store.getters[`${JOB_TEMPLATE_STORE}/estimateForm`]
);

const estimatePhaseNote = computed(
  () => store.getters[`${JOB_TEMPLATE_STORE}/getEstimatePhaseNotes`]
);

const dummyestimateForm = computed(
  () => store.getters[`${JOB_TEMPLATE_STORE}/getDummyEstimateForm`]
);

const newEstimatePhaseNote = computed(
  () => store.getters[`${JOB_TEMPLATE_STORE}/getUpdatedEstimatePhaseNotes`]
);
const deletedPhases = computed(() => {
  return props?.existingEstimatePhases?.filter((existingPhase: any) => {
    return !props?.modifiedEstimationPhases?.some(
      (modifiedPhase: any) => modifiedPhase?.id === existingPhase?.id
    );
  });
});

const newPhaseAttachment = (id: any) =>
  store.getters[`${JOB_TEMPLATE_STORE}/getphaseAttachmentsLocally`](id);

const projectEstimatePayload = (estimateForm: any, OldOrNew: boolean) => {
  let estimationPhaseData = [] as any;
  if (estimateForm) {
    estimateForm.projectStages.map((estimate: any, index: number) => {
      const endDate = estimate.totalDuration
        ? moment(estimate.startDate)
            .add(estimate.totalDuration, "days")
            .format("YYYY-MM-DD")
        : null;
      const estimateRecord = {
        id: estimate.id,
        name: estimate.name,
        phaseType: estimate.stageType === "labour" ? 1 : 2,
        durationType: estimate.durationType,
        phaseStartDate: estimate.startDate,
        phaseEndDate: endDate,
        vat: estimate.vat,
        subTotal: !estimate.subTotal
          ? "0"
          : typeof estimate.subTotal === "number"
          ? estimate.subTotal.toString()
          : estimate.subTotal,
        phaseOrder: estimate.phaseOrder,
        estimationPhaseTasks: [],
        estimationPhaseNotes: [],
        PhaseAttachments: [],
        estimationPhaseProperties: estimate.estimationPhaseProperties,
        color: estimate.color,
        user: estimate?.user,
        workStation: estimate?.workStation,
        grantAmount: estimate?.grantAmount,
        isPercentage: estimate?.isPercentage,
        isGranted: estimate?.isGranted,
        phaseUniqueId: estimate?.phaseUniqueId,
        assignTeamMembers: estimate?.assignTeamMembers,
      };

      if (OldOrNew) {
        let arr = estimatePhaseNote.value;
        if (estimatePhaseNote.value.length > 0) {
          for (const note of arr[estimate.id]) {
            if (note.task === null) {
              const estimatePhaseNote = {
                id: note.id,
                note: note.note,
                phaseId: estimate.phaseUniqueId,
                user: note.user.id,
                userWorkstation: note.userWorkstation.id,
                taskId: note.task,
                isEstimateNote: note.isEstimateNote,
              };
              estimateRecord?.estimationPhaseNotes.push(estimatePhaseNote);
            }
          }
        }
        if (estimate.attachments) {
          estimateRecord.PhaseAttachments.push(estimate.attachments);
        }
      } else if (!OldOrNew) {
        let arr2 = newEstimatePhaseNote.value;
        if (newEstimatePhaseNote.value.length > 0) {
          for (const note of arr2[estimate.phaseUniqueId]) {
            if (note.task === null) {
              const estimatePhaseNote = {
                id: note.id,
                note: note.note,
                phaseId: estimate.phaseUniqueId,
                user: note.user.id,
                userWorkstation: note.userWorkstation.id,
                taskId: note.task,
                isEstimateNote: note.isEstimateNote,
              };
              estimateRecord?.estimationPhaseNotes.push(estimatePhaseNote);
            }
          }
        }

        if (estimate.phaseUniqueId) {
          estimateRecord?.PhaseAttachments.push(
            newPhaseAttachment(estimate.phaseUniqueId)
          );
        }
        // estimateRecord.grantAmount =
        //   dummyestimateForm.value.projectStages[index].grantAmount;
        estimateRecord.grantAmount = estimate.grantAmount;
      }

      if (estimate?.projectStageTasks && estimate?.projectStageTasks?.length) {
        estimate?.projectStageTasks.map((task: any) => {
          const estimateTask = {
            id: task.isNew ? null : task.id,
            name: task.name,
            phaseTaskStartDate: task.startDate,
            phaseTaskEndDate: task.endDate,
            durationType: task.durationType,
            taskCost: !task.taskCost
              ? "0"
              : typeof task.taskCost === "number"
              ? task.taskCost.toString()
              : task.taskCost,
            estimationPhaseTasksProperties: task.estimationPhaseTasksProperties,
            materialUnit: task.materialUnit?.toString(),
            taskUniqueId: task.id,
            uniqueKey: task.isNew ? task.id : null,
          } as any;

          estimateRecord?.estimationPhaseTasks.push(estimateTask);
        });
      }
      estimationPhaseData.push(estimateRecord);
    });
  }

  return estimationPhaseData;
};
const existingModel = computed(() =>
  props.existingEstimatePhases?.map((_, index) => index)
);
const modifiedModel = computed(() =>
  props.modifiedEstimationPhases?.map((_, index) => index)
);

const getUpdatedEstimatePhaseNotes = computed(() => {
  return store.getters[`${JOB_TEMPLATE_STORE}/getUpdatedEstimatePhaseNotes`];
});
const submitUpdatedEstimate = async () => {
  try {
    loading.value = true;
    const initialEstimateData =
      getDefaultEstimateDetails.value?.projectStages.map((stage: any) => {
        return {
          ...stage,
          user: {
            id: stage.user.id,
          },
          workStation: {
            id: stage.workStation.id,
          },
        };
      });

    if (!formData.value?.id) {
      return;
    }

    const newEstimate = JSON.stringify({
      ...estimateForm.value,
      phaseNotes: getUpdatedEstimatePhaseNotes.value,
      formdata: formData.value,
    });
    const oldEstimate = JSON.stringify({
      projectStages: initialEstimateData,
    });

    const oldDbEstimate = JSON.stringify(
      projectEstimatePayload(
        {
          projectStages: initialEstimateData,
        },
        true
      )
    );

    const updatedDbEstimate = JSON.stringify(
      projectEstimatePayload(estimateForm.value, false)
    );

    const payloadData = {
      estimateId: formData.value.id,
      payload: {
        oldEstimate: oldEstimate,
        updatedEstimate: newEstimate,
        oldDbEstimate: oldDbEstimate,
        updatedDbEstimate: updatedDbEstimate,
      },
    };

    await store.dispatch(
      `${JOB_TEMPLATE_STORE}/updateEstimateRequest`,
      payloadData
    );
    displayToastMessage(
      internalInstance,
      "Change request Saved Estimate",
      "success"
    );

    onCancelEstimate();
  } catch (error: any) {
    console.log("error is the keyt", error);
    if (error.response) {
      if (error.response.status) {
        const errorMessage =
          error.response.data.message || "An error occurred. Please try again.";
        displayToastMessage(internalInstance, errorMessage, "error");
      } else {
        // Handle other status codes or errors
        displayToastMessage(
          internalInstance,
          `Error: ${error.response.statusText}`,
          "error"
        );
      }
    } else {
      displayToastMessage(
        internalInstance,
        "The request took too long and timed out. Please try again later.",
        "error"
      );
    }
  } finally {
    loading.value = false;
    // store.commit(`${JOB_TEMPLATE_STORE}/resetphasenote`);
  }
};
const onProceedToSubmit = () => {
  submitUpdatedEstimate();
};
const onCancelEstimate = () => {
  emits("on-back");
};

return (_ctx: any,_cache: any) => {
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              (__props.existingEstimatePhases?.length)
                ? (_openBlock(), _createBlock(_component_v_expansion_panels, {
                    key: 0,
                    multiple: "",
                    modelValue: existingModel.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((existingModel).value = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.existingEstimatePhases, (phase) => {
                        return (_openBlock(), _createBlock(EstimateUpdatePhaseModal, {
                          phaseDetails: phase,
                          key: phase.id,
                          highlightChanges: false
                        }, null, 8, ["phaseDetails"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              (__props.modifiedEstimationPhases.length)
                ? (_openBlock(), _createBlock(_component_v_expansion_panels, {
                    key: 0,
                    multiple: "",
                    modelValue: modifiedModel.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modifiedModel).value = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.modifiedEstimationPhases, (phase) => {
                        return (_openBlock(), _createBlock(EstimateUpdatePhaseModal, {
                          existingEstimatePhases: __props.existingEstimatePhases,
                          modifiedEstimationPhases: __props.modifiedEstimationPhases,
                          phaseDetails: phase,
                          key: phase.id,
                          highlightChanges: true
                        }, null, 8, ["existingEstimatePhases", "modifiedEstimationPhases", "phaseDetails"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              (deletedPhases.value?.length)
                ? (_openBlock(), _createBlock(_component_v_expansion_panels, {
                    key: 1,
                    multiple: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deletedPhases.value, (phase) => {
                        return (_openBlock(), _createBlock(EstimateUpdatePhaseModal, {
                          isDeletedPhase: true,
                          existingEstimatePhases: __props.existingEstimatePhases,
                          modifiedEstimationPhases: __props.modifiedEstimationPhases,
                          phaseDetails: phase,
                          key: phase?.id,
                          highlightChanges: false
                        }, null, 8, ["existingEstimatePhases", "modifiedEstimationPhases", "phaseDetails"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      (__props.isTradeSide)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            onClick: onCancelEstimate,
            class: "button button-purple-border",
            disabled: loading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Cancel ")
            ]),
            _: 1
          }, 8, ["disabled"]))
        : _createCommentVNode("", true),
      (__props.isTradeSide)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 1,
            onClick: onProceedToSubmit,
            class: "button button-purple",
            loading: loading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Submit Estimate ")
            ]),
            _: 1
          }, 8, ["loading"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})